import React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import { Page, Dashboard } from '../../components';
import Routes from '../../routes';
import config from '../../config';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeLang = this.handleChangeLang.bind(this);
  }

  handleChangeLang(e) {
    this.props.dispatch({
      type: 'app/updateStore',
      payload: { locale: e.target.value, messages: {} },
    });
  }

  render() {
    const { app, loading, children } = this.props;
    const hiddenDashboard = [
      Routes.LOGIN.path,
      Routes.LOGOUT.path,
      Routes.FORGOT_PASSWORD.path,
      Routes.RECOVER_PASSWORD.path,
      Routes.FIRST_LOGIN.path,
    ].includes(app.location.pathname);

    if (!app.messages[app.locale]) {
      return null;
    }

    const messages = Object.assign(
      {},
      app.messages[config['app.fallback_locale']],
      app.messages[app.locale],
    );

    return (
      <Page
        loading={!!loading.effects['app/start'] || !!loading.effects['app/authenticated']}
        className="app"
        key={app.location} location={app.location}
      >
        <IntlProvider
          locale={app.locale}
          key={app.locale}
          messages={messages}
          location={app.location}
        >
          {hiddenDashboard ?
            children :
            <Dashboard>{children}</Dashboard>
          }
        </IntlProvider>
      </Page>
    );
  }
}

export default withRouter(connect(({ app, loading }) => ({ app, loading }))(App));



// WEBPACK FOOTER //
// ./src/routes/app/index.js